<template>
  <div>
    <div class="image-upload-wrap">
      <span class="image-title-wrap">{{title}}</span>
      <div class="image-add-wrap">
          <div class="image-lists"> 
            <div class="image-list stop" v-if="disabled">
              <label for="upload">
                <img src="../../../../assets/images/notAddImg.png" alt="">
              </label>
            </div>
            <div class="image-list" v-else>
              <label for="upload">
                <img src="../../../../assets/images/addImg.png" alt="">
                <input type="file" id="upload" name="file" multiple accept="image/jpg,image/jpeg,image/png" @change="upload($event)"/>
              </label>
            </div>
            <div v-show="showImg" class="formImg" :style="style.form_display">
              <img :src="imgUrl" alt="" :style="style.form_display">
              <!-- <img :src="imgUrl" alt="" if="showImg"> -->
              <span class="del" @click="delImage" v-if="!disabled">-</span>
              <!-- 悬浮大图 -->
              <img :src="imgBigUrl" alt="" class="formBigImg" v-if="formImgShow">
            </div>
          </div>
      </div>
    </div>
    <div v-show="editImg">  
      <div class="operation-area">
        <div class="operation-btns">
          <el-button type="primary" @click="saveImg">保存图片</el-button>
          <el-button type="danger" @click="cancelImg">取消</el-button>
        </div>
      </div>
      <div class="operation-img">
        <div :style="operationBox" class="cropper-img">
            <vueCropper
            ref="cropper"
            :img="imgInfo.img"
            :outputSize="imgInfo.size"
            :outputType="imgInfo.outputType"
            :info="imgInfo.info"
            :canScale="imgInfo.canScale"
            :autoCrop="imgInfo.autoCrop"
            :autoCropWidth="imgInfo.width"
            :autoCropHeight="imgInfo.height"
            @realTime="realTime"
          ></vueCropper>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import http from '../../../../assets/js/http'
  import vueCropper from 'vue-cropper'
  import modelConfig from '../../../../config/modelConfig'
  export default {
    props: ['value', 'title', 'name', 'disabled', 'config', 'uploadUrl'],
    data() {
      return {
        images: [],
        imgUrl: '',
        imgBigUrl: '',
        postImgUrl: {},
        mobile_config: {
          from: 0,
          readonly_size_form: {
            width: '',
            height: ''
          }
        },
        thumb_image: [],
        formImgShow: false,
        listImgShow: false,
        suspension_type: [],
        imgInfo: {
          img: '',
          info: true,
          size: 1,
          outputType: 'jpg',
          canScale: true,
          autoCrop: true,
          // 只有自动截图开启 宽度高度才生效
          width: 300,
          height: 250
        },
        editImg: false,
        showImg: false,
        style: {
          list_display: {
            width: '',
            height: ''
          },
          form_display: {
            width: '',
            height: ''
          }
        },
        operationBox: {
          width: '500px',
          height: '500px'
        }
      }
    },
    created() {
      if (this.config) {
        // 选择框宽高比例
        if (this.config.deal_config.is_fix_scale == 1) {
          let base = 50 // 缩放比例的基数
          this.imgInfo.height = this.config.deal_config.fix_scale_config[0] * base
          this.imgInfo.width = this.config.deal_config.fix_scale_config[1] * base
        }
        // 初始化图片范围的宽高
        if (this.config.deal_config.is_zoom == 1) {
          if (this.config.deal_config.zoom_config.width != '') {
            this.operationBox.width = this.config.deal_config.zoom_config.width + 'px'
          }
          if (this.config.deal_config.zoom_config.height != '') {
            this.operationBox.height = this.config.deal_config.zoom_config.height + 'px'
          }
        }
        // 是否生成缩略图
        if (this.config.thumb_config && this.config.thumb_config.is_thumb == 1) {
          _(this.config.thumb_config.config).forEach((thumb) => {
            this.thumb_image.push({
              width: thumb.width,
              height: thumb.height,
              thumb_type: thumb.thumb_type,
              url: ''
            })
          })
        }
        // 判断列表或者表单是否悬浮显示大图 10表单 20列表
        if (this.config.display_config.suspension_type && this.config.display_config.suspension_type.length > 0) {
          this.suspension_type = this.config.display_config.suspension_type
        }
        // 获取移动端的配置
        if (this.config.mobile_config) {
          this.mobile_config = {
            from: this.config.mobile_config.from,
            readonly_size_form: {
              width: this.config.mobile_config.readonly_size_form.width + 'px',
              height: this.config.mobile_config.readonly_size_form.height + 'px'
            }
          }
        }
      }
      // 初始化表单/列表的宽高
      this.style.form_display = {
        width: this.config.display_config.form_display.width + 'px',
        height: this.config.display_config.form_display.height + 'px'
      }
      this.style.list_display = {
        width: this.config.display_config.list_display.width + 'px',
        height: this.config.display_config.list_display.height + 'px'
      }
      if (this.value && this.value != null) {
        this.showImg = true
        this.formImgShow = true
        this.imgUrl = this.value.deal_image
        this.imgBigUrl = this.value.deal_image
      }
    },
    methods: {
      upload(e) {
        // 图片处理 IMG_NODEAL(10不处理) IMG_FRONTDEAL(20前端处理) IMG_BACKGROUNDDEAL(30后端处理)
        // 上传图片
        let type = this.config.deal_config.type
        let file = e.target.files[0]
        if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
          _g.toastMsg(this, 'error', '图片类型必须是.gif,jpeg,jpg,png,bmp中的一种')
          return false
        }
        // 图片处理
        if (this.config) {
          // 大小限制处理
          if (this.config.size_limit && this.config.size_limit.is_limited == 1) {
            let size_limit = this.config.size_limit
            let size = size_limit.size
            if (file.size < size) {
              _g.toastMsg(this, 'error', '大小不能超过' + size + 'KB')
              return false
            }
          }
        }
        let reader = new FileReader()
        if (type == this.IMG_NODEAL) {
          reader.onload = (e) => {
            let postData = {
              base64file: e.target.result
            }
            this.postImgFun(postData)
          }
        } else if (type == this.IMG_FRONTDEAL) {
          this.editImg = true
          reader.onload = (e) => {
            this.imgInfo.img = e.target.result
          }
        } else if (type == this.IMG_BACKGROUNDDEAL) {
          reader.onload = (e) => {
            let postData = {
              base64file: e.target.result
            }
            this.postImgFun(postData)
          }
        }
        reader.readAsDataURL(file)
        document.getElementById('upload').value = null
      },
      delImage() {
        this.showImg = false
        this.imgUrl = ''
        document.getElementById('upload').value = null
        this.change()
      },
      change() {
        this.$emit('input', this.postImgUrl)
      },
      // 实时预览函数
      realTime(data) {
        this.previews = data
      },
      saveImg() {
        this.$refs.cropper.getCropData((data) => {
          let postData = {
            base64file: data
          }
          this.postImgFun(postData)
        })
      },
      postImgFun(postData) {
        this.apiPost(this.uploadUrl, postData).then((res) => {
          if (res.code == 200) {
            this.editImg = false
            this.showImg = true
            let deal_image = ''
            let thumb_image = []
            if (res.data.deal_image == null || res.data.deal_image == '') {
              deal_image = res.data.deal_image
            } else {
              deal_image = imgUrl + res.data.deal_image
              this.imgUrl = imgUrl + res.data.deal_image
              this.imgBigUrl = imgUrl + res.data.deal_image
            }
            // 保存缩略图
            if (res.data.thumb_image == null || res.data.thumb_image == '') {
              this.thumb_image = res.data.thumb_image
            } else {
              for (let i = 0; i < res.data.thumb_image.length; i++) {
                this.thumb_image[i].url = res.data.thumb_image[i]
              }
            }
            // 根据suspension_type判断是否列表/表单需要悬浮
            if (this.suspension_type && this.suspension_type.length > 0) {
              _(this.suspension_type).forEach((res) => {
                if (res == 10) {
                  this.formImgShow = true
                } else if (res == 20) {
                  this.listImgShow = true
                }
              })
            }
            this.postImgUrl = {
              deal_image: imgUrl + res.data.deal_image,
              thumb_image: this.thumb_image,
              list_display: {
                width: this.config.display_config.list_display.width + 'px',
                height: this.config.display_config.list_display.height + 'px'
              },
              listImgShow: this.listImgShow,
              mobile_config: this.mobile_config
              // form_display: {
              //   width: this.config.display_config.form_display.width + 'px',
              //   height: this.config.display_config.form_display.height + 'px'
              // }
            }
            this.change()
          } else {
            _g.toastMsg(this, 'error', res.error)
          }
        })
      },
      cancelImg() {
        this.editImg = false
      }
    },
    mixins: [http, modelConfig],
    components: {
      vueCropper
    }
  }
</script>
<style scoped>
  .image-upload-wrap{
    width: 100%;
    float: left;
  }
  .image-add-wrap{
    margin-top:10px;
    padding:0 15px 10px 15px;
  }
  .image-lists  label{
    display: inline-block;
    width:100%;
    height:100%;
    position: relative;
  }
  .image-lists  label img{
    width: 100%;
    height: 100%;
  }
  .image-lists  input{
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    opacity:0;
    cursor: pointer
  }
  .image-lists{
    width: 100%;
    margin: 0;
    padding: 0;
  }
  .image-list{
    width:100px;
    height:100px;
    margin-right:3%;
    position: relative; 
    cursor: pointer;
    float: left;
  }
  .formImg{position:relative;display:inline-block}
  .del{
    display:block;
    position:absolute;
    right: -25px;
    top: -15px;
    width:18px;
    height:18px;
    border-radius:50%;
    background-color:#c9394d;
    text-align:center;
    line-height:17px;
    color: #fff;
    font-size: 16px;
    cursor: pointer
  }
  .image-list img{
    width: 100%;
    height: 100%;
  }
  .operation-area{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.6);
    z-index: 9;
  }
  .operation-img{
    position: fixed;
    top: 50%;
    left: 50%;
    width:500px;
    height:500px;
    margin-left: -250px;
    margin-top: -215px;
    z-index: 10;
    overflow:hidden;
  }
  .operation-btns{
    width: 200px;
    position: absolute;
    left:50%;
    top: 75px;
    margin-left:-100px;
  }
  .cropper-view-box img{
    width:300px;
    height: 300px;
  }
  .formImg{
    cursor: pointer
  }
  .formImg:hover .formBigImg{
    display: inline-block;
    z-index:11;
  }
  .formBigImg{
    display:none; 
    position:absolute;
  }
  .cropper-img{
    margin:0 auto;
  }
</style>


// WEBPACK FOOTER //
// honrayUploadImg.vue?852e9030